const removeNullAndUndefinedValue = (obj?: Record<string, any>) => {
  if (!obj) {
    return {}
  }

  return Object.entries(obj).reduce((a, [k, v]) => {
    if (v === null) {
      return a
    }
    if (typeof v === 'undefined') {
      return a
    }

    a[k] = v
    return a
  }, {})
}

export default removeNullAndUndefinedValue
